angular.module('impactx.basketLink').controller('SupplierSelectionDialogCtrl', SupplierSelectionDialogCtrl);

SupplierSelectionDialogCtrl.$inject = ['$scope', 'dataGen', 'TranslationService', '$mdDialog', 'proId', 'amount'];

function SupplierSelectionDialogCtrl($scope, dataGen, TranslationService, $mdDialog, proId, amount)
{
    var ctrl = this;

    ctrl.amount = amount;

    ctrl.getData = function () {
        var paramObj = {
            proId: proId
        };
        dataGen.getData($scope, paramObj, '/product/collect/selectsupplier').then(function () {
            $scope.trns.abort = TranslationService.get('abort');
            $scope.trns.addToBasket = TranslationService.get('addToBasket');
            angular.forEach($scope.data.products, function(pro) {
                pro.basketLink.amount = ctrl.amount;
            });
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    };

    ctrl.getData();
}